import { Box, Typography } from "@mui/material";
import { getWorkshopCategories, getWorkshopLabel } from "./utils";

const WorkshopInfo = ({ workshop }: { workshop?: string | null }) => (
    <Box
        sx={{
            border: "1px solid #E5EAF1",
            borderRadius: "8px",
            backgroundColor: "#FFFFFF",
            p: "18px 20px",
            fontFamily: "Noto Sans",
        }}
    >
        <Typography
            sx={{
                color: "#333739",
                fontFamily: "Noto Sans",
                fontSize: "16px",
                fontWeight: 700,
                mb: "12px",
            }}
        >
            Thông tin xưởng
        </Typography>
        <Typography
            sx={{
                color: "#526171",
                fontFamily: "Noto Sans",
                fontSize: "13px",
                mb: "4px",
            }}
        >
            Xưởng sản xuất
        </Typography>
        <Typography
            sx={{
                color: "#1F2937",
                fontFamily: "Noto Sans",
                fontSize: "15px",
                fontWeight: 600,
            }}
        >
            {getWorkshopLabel(workshop)}
        </Typography>
        <Typography
            sx={{
                color: "#526171",
                fontFamily: "Noto Sans",
                fontSize: "13px",
                mt: "12px",
                mb: "4px",
            }}
        >
            Danh mục được phép
        </Typography>
        <Typography
            sx={{
                color: "#1F2937",
                fontFamily: "Noto Sans",
                fontSize: "15px",
                fontWeight: 600,
            }}
        >
            {getWorkshopCategories(workshop).join(", ") || "Chưa có"}
        </Typography>
    </Box>
);

export default WorkshopInfo;
